import Vue from "vue"
/* import menusApi from "../../api/menus" */
import utilsApi from "@/api/utils"
import { createFetchPageAction } from "@/store/helpers/createFetchPageAction"
const initialObject = {
  _id: undefined,
  name: undefined,
  body: undefined,
  status: undefined,
  createdAt: undefined,
  updatedAt: undefined
}
const objectFieldsToSend = ["name", "body", "status", "_id"]
const objectToSend = (object) => {
  return Object.keys(object)
    .filter((key) => objectFieldsToSend.includes(key))
    .reduce((obj, key) => {
      obj[key] = object[key]
      return obj
    }, {})
}
// general state for the site

//test backlinks
/* const backlinks = [
  {
    _id: "id",
    name: "primer back link",
    value: [{ component: "div" }],
    status: true,
    createdAt: "20-08-19",
    updatedAt: "20-08-19"
  }
] */

const initialState = {
  menus: [],
  count: 0,
  page: 1,
  fetched: false,
  error: false,
  object: initialObject,
  isNew: false,
  selected: []
}

const state = Object.assign({}, initialState)

const getters = {
  menus: (state) => state.menus,
  menusIndex: (state) => (payload) => {
    //console.log(state.menus)
    const { param, parent, key } = payload || {}
    return payload
      ? param
        ? key
          ? parent
            ? state[param] && state[param][parent] && state[param][parent][key]
              ? state[param][parent][key]
              : undefined
            : state[param] && state[param][key]
            ? state[param][key]
            : undefined
          : state[param]
          ? state[param]
          : undefined
        : state
      : state
  },
  menusError: (state) => state.error,
  menus_Object: (state) => state.object,
  menus_isNew: (state) => state.isNew,
  menus_selected: (state) => state.selected
}
const actions = {
  async DELETE_menus({ commit, dispatch, state }, object) {
    let apiResponse = await utilsApi.deleteObject("menus", object)
    if (apiResponse != null) {
      //commit("MENUS_SETTING", apiResponse)
      dispatch("FETCH_PAGE_menus", state.page)
      //console.log("PAGE MENU", state.page)
      return true
    } else {
      commit("MENUS_ERROR")
      return false
    }
  },
  async DELETE_SELECTED_menus({ state, dispatch, commit }) {
    let deletions = await Promise.all(
      state.selected.map(async (current) => {
        return await dispatch("DELETE_menus", current)
      })
    )
    if (deletions.includes(false)) {
      return false
    } else {
      commit("SET_menus", {
        param: "selected",
        value: []
      })
      return true
    }
  },
  UPDATE_menusState({ commit }, payload) {
    commit("SET_menus", payload)
    return true
  },
  async UPDATE_menus({ commit, dispatch, state }, object) {
    let apiResponse = await utilsApi.updateObject("menus", objectToSend(object))
    if (apiResponse != null) {
      commit("MENUS_SETTING", apiResponse)
      dispatch("FETCH_PAGE_menus", state.page)
      return true
    } else {
      commit("MENUS_ERROR")
      return false
    }
  },
  async CREATE_menus({ commit, dispatch, state }, object) {
    let apiResponse = await utilsApi.createObject("menus", objectToSend(object))
    if (apiResponse != null) {
      commit("SET_menus", {
        param: "object",
        value: apiResponse.menu
      })
      dispatch("FETCH_PAGE_menus", state.page)
      return true
    } else {
      commit("MENUS_ERROR")
      return false
    }
  },
  async FETCH_menus({ commit }) {
    let apiResponse = await utilsApi.getObjects("menus")
    //console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("MENUS_SETTING", apiResponse)
      return true
    } else {
      commit("MENUS_ERROR")
      return false
    }
  },

  FETCH_PAGE_menus: createFetchPageAction(
    "menus",
    "MENUS_SETTING",
    "MENUS_ERROR",
    "menus"
  ),

  UPDATE_OBJECT_menus({ commit }, payload) {
    commit("SET_OBJECT_MENU", payload)
    return true
  },
  CLEAN_OBJECT_menus({ commit }) {
    commit("SET_OBJECT_MENU_INITIAL")
    return true
  },
  async CLEAN_STORE_menus({ commit }) {
    const initialStateKeys = Object.keys(initialState)
    await Promise.all(
      initialStateKeys.map(async (current) => {
        await commit("SET_menus", {
          param: current,
          value: initialState[current]
        })
        return true
      })
    )
    return true
  },
  UPDATE_SELECTED_menus({ commit }, payload) {
    commit("SET_SELECTED_MENUS", payload)
    return true
  }
}
const mutations = {
  MENUS_SETTING: (state, { menus, count = undefined, page }) => {
    state.count = count ?? state.menus.length
    state.page = page ?? state.page
    state.menus = menus
    state.fetched = true
    state.error = false
  },
  MENUS_ERROR: (state) => {
    state.menus = null
    state.fetched = true
    state.error = false
  },
  SET_OBJECT_MENU: (state, payload) => {
    Object.keys(initialObject).map((key) => {
      state.object[key] = payload[key]
    })
  },
  SET_OBJECT_MENU_INITIAL: (state) => {
    state.object = { ...state.object, ...initialObject }
  },
  SET_SELECTED_MENUS: (state, selectedMenus) => {
    state.selected = selectedMenus
  },
  SET_menus: (state, payload) => {
    const { param, parent, key, value } = payload
    //console.log("SETTING FORMS STATE IN", param, value, key, parent)
    key
      ? parent
        ? state[param]
          ? state[param][parent]
            ? Vue.set(state[param][parent], key, value)
            : Vue.set(state[param], parent, {}) &&
              Vue.set(state[param][parent], key, value)
          : Vue.set(state, param, {}) &&
            Vue.set(state[param], parent, {}) &&
            Vue.set(state[param][parent], key, value)
        : state[param]
        ? Vue.set(state[param], key, value)
        : Vue.set(state, param, {}) && Vue.set(state[param], key, value)
      : Vue.set(state, param, value)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
